import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import dateFormat from "../../lib/dateFormat";

const SITE_URL =
  "https://fastidious-lamington-55c5c5.netlify.app/" ||
  "https://www.balotazh.com";

const buildCanonicalUrl = (post) => {
  const path = `/news/${post.id}`;
  console.log(path);
  try {
    return new URL(path, SITE_URL).toString();
  } catch {
    return `${SITE_URL.replace(/\/$/, "")}${path}`;
  }
};

const LatestNews = ({ posts = [], loading }) => {
  const [hoveredPost, setHoveredPost] = useState(null);

  const sortedPosts = useMemo(() => {
    return [...posts].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
  }, [posts]);

  const latestPost = sortedPosts[0];

  const handleShare = (e, platform, post) => {
    e.preventDefault();
    e.stopPropagation();
    if (!post) return;
    console.log(post);
    const shareUrl = buildCanonicalUrl(post);
    const title =
      post.title[0] ||
      (typeof document !== "undefined" ? document.title : "Balotazh");
    console.log(shareUrl);
    const openPopup = (url) => {
      window.open(url, "_blank", "noopener,noreferrer");
      console.log(url);
    };

    if (platform === "facebook") {
      openPopup(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareUrl
        )}&quote=${encodeURIComponent(title)}`
      );
      return;
    }
    if (platform === "twitter") {
      openPopup(
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          shareUrl
        )}&text=${encodeURIComponent(title)}`
      );
      return;
    }
    if (platform === "linkedin") {
      openPopup(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          shareUrl
        )}`
      );
      return;
    }
    if (platform === "whatsapp") {
      openPopup(
        `https://wa.me/?text=${encodeURIComponent(`${title} ${shareUrl}`)}`
      );
      return;
    }
    if (
      platform === "native" &&
      typeof navigator !== "undefined" &&
      navigator.share
    ) {
      navigator.share({ title, text: title, url: shareUrl }).catch(() => {});
      return;
    }
    if (platform === "copy") {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(shareUrl).catch(() => {});
      } else {
        const input = document.createElement("input");
        input.value = shareUrl;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }
      return;
    }
  };

  // Skeletons
  const FeaturedNewsSkeleton = () => (
    <div className="news-card-skeleton featured">
      <div className="skeleton-news-image"></div>
      <div className="skeleton-news-content">
        <div className="skeleton-news-category"></div>
        <div className="skeleton-news-title"></div>
        <div className="skeleton-news-meta"></div>
      </div>
    </div>
  );

  const NewsCardSkeleton = () => (
    <div className="news-card-skeleton">
      <div className="skeleton-news-image"></div>
      <div className="skeleton-news-content">
        <div className="skeleton-news-category"></div>
        <div className="skeleton-news-title"></div>
        <div className="skeleton-news-meta"></div>
      </div>
    </div>
  );

  return (
    <section className="latest-news-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Lajmet e fundit</h2>
          <Link to="/category/lajme" className="see-more-btn">
            shiko më shumë <i className="fas fa-arrow-right"></i>
          </Link>
        </div>

        <div className="row">
          {loading ? (
            <>
              <div className="col-lg-6 mb-4">
                <FeaturedNewsSkeleton />
              </div>
              {Array.from({ length: 4 }).map((_, index) => (
                <div
                  key={`skeleton-${index}`}
                  className="col-lg-3 col-md-6 mb-4"
                >
                  <NewsCardSkeleton />
                </div>
              ))}
            </>
          ) : sortedPosts && sortedPosts.length > 0 && latestPost ? (
            sortedPosts.slice(0, 4).map((post, index) => (
              <div
                key={post.id}
                className={`${index === 0 ? "col-lg-12" : "col-lg-4 col-md-6"} mb-4`}
              >
                <article
                  className={`news-card ${index === 0 ? "featured" : ""} ${hoveredPost === post.id ? "hovered" : ""}`}
                  onMouseEnter={() => setHoveredPost(post.id)}
                  onMouseLeave={() => setHoveredPost(null)}
                >
                  <div className="news-image">
                    <Link to={`/news/${post.id}`}>
                      <img
                        src={post.image_url}
                        alt={post.title}
                        loading="lazy"
                      />
                    </Link>
                    <div className="news-overlay">
                      <span className="news-category">
                        <i className="fas fa-newspaper"></i>
                        {post.categories?.[0] || "News"}
                      </span>
                      {index === 0 && (
                        <div className="news-badge">
                          <i className="fas fa-star"></i>
                          Kryesore
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="news-content">
                    <h3 className="news-title">
                      <Link to={`/news/${post.id}`}>{post.title}</Link>
                    </h3>

                    {index === 0 && (
                      <p className="news-excerpt">
                        {(post.content || "")
                          .replace(/<[^>]*>/g, "")
                          .slice(0, 150)}
                        ...
                      </p>
                    )}
                    {index === 0 && (
                      <div className="article-excerpt">
                        <p className="lead" itemProp="description">
                          {post.excerpt}
                        </p>
                      </div>
                    )}
                    {index === 0 ? (
                      post.content ? (
                        <div
                          dangerouslySetInnerHTML={{ __html: post.content }}
                        />
                      ) : (
                        <p>{post.excerpt}</p>
                      )
                    ) : null}
                    {index === 0 && post.tags && post.tags.length > 0 && (
                      <div className="article-tags">
                        <h4>Etiketat:</h4>
                        <div className="tags-list">
                          {post.tags.map((tag, i) => (
                            <span key={i} className="tag">
                              #{tag}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                    {index === 0 && (
                      <div className="share-buttons">
                        <button
                          className="share-btn facebook"
                          onClick={(e) => handleShare(e, "facebook", post)}
                          aria-label="Ndaj në Facebook"
                        >
                          <i className="fab fa-facebook-f"></i>
                          <span>Facebook</span>
                        </button>
                        <button
                          className="share-btn twitter"
                          onClick={(e) => handleShare(e, "twitter", post)}
                          aria-label="Ndaj në Twitter"
                        >
                          <i className="fab fa-twitter"></i>
                          <span>Twitter</span>
                        </button>
                        <button
                          className="share-btn linkedin"
                          onClick={(e) => handleShare(e, "linkedin", post)}
                          aria-label="Ndaj në LinkedIn"
                        >
                          <i className="fab fa-linkedin-in"></i>
                          <span>LinkedIn</span>
                        </button>
                        <button
                          className="share-btn whatsapp"
                          onClick={(e) => handleShare(e, "whatsapp", post)}
                          aria-label="Ndaj në WhatsApp"
                        >
                          <i className="fab fa-whatsapp"></i>
                          <span>WhatsApp</span>
                        </button>
                        <button
                          className="share-btn copy"
                          onClick={(e) => handleShare(e, "copy", post)}
                          aria-label="Kopjo linkun"
                        >
                          <i className="fas fa-link"></i>
                          <span>Kopjo linkun</span>
                        </button>
                        {typeof navigator !== "undefined" &&
                          navigator.share && (
                            <button
                              className="share-btn native"
                              onClick={(e) => handleShare(e, "native", post)}
                              aria-label="Ndaj"
                            >
                              <i className="fas fa-share-alt"></i>
                              <span>Ndaj</span>
                            </button>
                          )}
                      </div>
                    )}
                  </div>
                </article>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="no-news-message">
                <div className="no-news-icon">
                  <i className="fas fa-newspaper"></i>
                </div>
                <h3>Nuk ka lajme të fundit</h3>
                <p>Nuk ka lajme të fundit të disponueshme për momentin.</p>
                <Link to="/category/lajme" className="browse-news-btn">
                  <i className="fas fa-search"></i>
                  Shfleto kategorinë
                </Link>
              </div>
            </div>
          )}
        </div>

        {sortedPosts && sortedPosts.length > 0 && (
          <div className="quick-updates">
            <div className="updates-header">
              <span className="updates-label">
                <i className="fas fa-bolt"></i>
                Përditësimet e fundit
              </span>
            </div>
            <div className="updates-list">
              {sortedPosts.slice(0, 3).map((post) => (
                <div key={post.id} className="update-item">
                  <Link to={`/news/${post.id}`} className="update-link">
                    <div className="update-content">
                      <h4 className="update-title">{post.title}</h4>
                      <div className="update-meta">
                        <span className="update-time">
                          <i className="far fa-clock"></i>
                          {dateFormat(post.created_at)}
                        </span>
                        <span className="update-category">
                          {post.categories?.[0] || "News"}
                        </span>
                      </div>
                    </div>
                    <div className="update-arrow">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LatestNews;
